module.exports = __webpack_public_path__ + "img/p-19.7e571c73.jpg";